"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.main = exports.merge = exports.keys = undefined;
exports.has = has;
exports.find = find;
exports.lookup = lookup;
exports.exists = exists;
exports.cloneArr = cloneArr;
exports.toArray = toArray;
exports.arrRemove = arrRemove;
exports.removeItem = removeItem;
exports.indexOf = indexOf;
exports.prefetch = prefetch;
exports.median = median;
exports.average = average;
exports.min = min;
exports.max = max;
exports.inherit = inherit;
exports.log = log;
exports.warn = warn;
exports.log = log;
exports.sendSelectedText = sendSelectedText;
exports.bindParent = bindParent;
exports.openLinkInNewWindow = openLinkInNewWindow;
exports.isNewerVersion = isNewerVersion;
exports.CallbackGroup = CallbackGroup;
exports.logStorage = logStorage;
exports.overload = overload;

var _utilsPolyfills = require("./utils.polyfills.js");

var _Chegg = require("./Chegg.js");

var utils = {};

_Chegg.Chegg.utils = utils;

//shorthand for object.hasOwnProperty
function has(obj, item) {
    return Object.prototype.hasOwnProperty.call(obj, item);
}

/**
 * returns the value of a chain of variables if exists
 *
 * instead of doing
 * loaded = (book && book.current_page && book.current_page.loaded)
 *
 * you can do
 *
 * loaded = find(book,'current_page','loaded');
 *
 * or
 *
 * loaded = find(book,'current_page.loaded');
 *
 */
function find(obj /*[,item [,item ...]]*/) {
    var list = Array.prototype.splice.call(arguments, 1),
        name;

    if (!obj) return obj;

    if (list.length == 1 && list[0].indexOf('.') > -1) {
        list = list[0].split('.');
    }

    while (name = list.shift()) {
        if (obj == null) return null;
        obj = obj[name];
    }

    return obj;
}

/**
 * Same as find, only that you can provide an alternative result if find fails
 * @param obj
 * @param map
 * @param alternative
 * @returns {*}
 */
function lookup(obj, map, alternative) {
    var result = find(obj, map);

    if (alternative && result == null) return alternative;

    return result;
}

/*
 * checks for long chains of existance
 *
 * instead of doing if (book && book.current_page && book.current_page.loaded)
 *
 * if (exists(book,'current_page','loaded')) ...
 *
 * or
 *
 * if (exists(book,'current_page.loaded')) ....
 *
 */
function exists(obj /*[,item [,item ...]]*/) {
    return find.apply(null, arguments) != null;
}

function cloneArr(arr) {
    return Array.prototype.splice.call(arr, 0);
}

function toArray(item) {
    return item instanceof Array ? item : [item];
}

//removes an item from an array based on it's index
function arrRemove(arr, index) {
    return arr.splice(index, 1);
}

function removeItem(arr, item) {
    var index = arr.indexOf(item);
    if (index < 0) return;

    return arr.splice(index, 1);
}

function indexOf(arr, item) {
    return [].indexOf.call(arr, item);
}

var keys = exports.keys = Object.keys || function (obj) {
    var arr = [],
        key;
    for (key in obj) {
        if (has(obj, key)) arr.push(key);
    }return arr;
};

var merge = exports.merge = Object.merge || function (target, params) {
    var key, i, obj;

    for (i = 1; obj = arguments[i]; i++) {
        for (key in obj) {
            if (has(obj, key)) {
                target[key] = obj[key];
            }
        }
    }

    return target;
};

function prefetch() {
    var i, src, img;

    for (i = 0; src = arguments[i]; i++) {
        img = new Image();
        img.src = src;
    }
}

function median(values) {
    var half;

    values.sort(function (a, b) {
        return a - b;
    });

    half = Math.floor(values.length / 2);

    if (values.length % 2) return values[half];else return (values[half - 1] + values[half]) / 2.0;
}

function average(values) {
    var sum = 0;

    values.forEach(function (value) {
        sum += value;
    });

    return sum / values.length;
}

function min(values) {
    return Math.min.apply(null, values);
}

function max(values) {
    return Math.max.apply(null, values);
}

function inherit(obj, parent, props) {
    var key;
    function F() {}

    F.prototype = parent.prototype;
    obj.prototype = new F();
    obj.prototype.constructor = obj;
    obj.prototype.$_parent = parent;

    for (key in props) {
        if (has(props, key)) {
            obj.prototype[key] = props[key];
        }
    }obj.prototype.$parent = function (name, args) {
        if (!this.$parent_stack) this.$parent_stack = {};

        var old = this.$parent_stack[name],
            chain = this.$_parent,
            result;

        if (!old) {
            this.$parent_stack[name] = chain.prototype;
        } else {
            this.$parent_stack[name] = chain.prototype.$_parent.prototype;
        }

        result = this.$parent_stack[name][name].apply(this, args || []);

        this.$parent_stack[name] = old;

        return result;
    };

    obj.prototype.$construct = function (args) {
        if (!this.$parent_stack) this.$parent_stack = {};

        var result,
            parent,
            old = this.$parent_stack['$_parent'];

        if (!old) {
            parent = this.$_parent;
        } else {
            parent = this.$parent_stack['$_parent'].prototype.$_parent;
        }

        this.$parent_stack['$_parent'] = parent;

        result = parent.apply(this, args || []);

        this.$parent_stack['$_parent'] = old;

        return result;
    };

    return obj;
}

function log(arg1, arg2) {
    if (Chegg.prod) return;

    if (exists(window, 'console.log')) {
        console.log.apply ? console.log.apply(console, arguments) : console.log(arg1, arg2);
    }
}

function warn(arg1, arg2) {
    if (Chegg.prod) return;

    var fn_name = exists(window, 'console.warn') ? 'warn' : exists(window, 'console.log') ? 'log' : null;

    if (!fn_name) return;

    console[fn_name].apply ? console[fn_name].apply(console, arguments) : console[fn_name](arg1, arg2);
    console.trace && console.trace();
}

function log(a, b) {
    if ('console' in window) console.log(a, b);
}

/**
 * sendSelectedText used by logItem.prepare method to parse MenuSelection context.selectedText and highlight type
 * @param e : LogItem object
 */
function sendSelectedText(e) {
    var args = e.args,
        selectedText = _Chegg.Chegg.utils.find(args, 'context.selectedText');

    if (!selectedText) {
        selectedText = _Chegg.Chegg.utils.find(args, 'selectedText');
    }

    if (!selectedText) {
        return false;
    }

    this.value = selectedText.length;

    if (args.type) {
        this.label = args.type;
    }
}

/**
 * a syntax sugar for calling other object's methods on an object
 *
 * Returned function will function just like inherit's $parent, only that if you only pass it arguments it will call the constructor (like inherit#$construct)
 *
 * @method bindParent
 * @static
 *
 * @param {Object} target object
 * @param {Object} parent object
 * @param {bool}   [use_directly] if set to true, will use parent directly, rather than use it's prototype
 *
 * @example
 *
 *    this.parent = utils.bindParent(this, Foo);
 *
 *    this.parent([some_arg]); //will call Foo - bound to obj
 *    this.parent('bar',[some_arg]); //will call Foo.prototype.bar - bound to obj
 *
 * @return {Function}
 */
function bindParent(obj, parent, use_directly) {
    var construct = parent;

    if (!use_directly) {
        parent = parent.prototype;
    }

    return function (method, args) {
        if (!args && typeof method != 'string') {
            args = method;
            method = construct;
        } else {
            method = parent[method];
        }

        return method.apply(obj, args || []);
    };
}

/**
 * provide a way to open link in new Safari mobile window while the application is in home screen mode (running as standalone web app)
 * @param url {String} target url
 */
function openLinkInNewWindow(url) {
    var link = document.createElement('a'),
        clickevent = document.createEvent('Event');

    link.target = '_blank';
    link.href = url;

    clickevent.initEvent('click', true, false);
    link.dispatchEvent(clickevent);
}

/**
 * a method to find if the current version is newer then a specific one.
 * @param new_version {string}
 * @param version {string}
 * @return {boolean}
 */
function isNewerVersion(new_version, version) {
    var i, length;

    if (!new_version || typeof new_version !== 'string' || !version || typeof version !== 'string') {
        console.warn('isNewerVersion inputs must be as string type');
        return false;
    }

    if (version === new_version) {
        return true;
    }

    version = version.split('.');
    new_version = new_version.split('.');
    length = Math.max(new_version.length, version.length);

    for (i = 0; i < length; ++i) {
        if (parseInt(new_version[i] || 0, 10) > parseInt(version[i] || 0, 10)) {
            return true;
        } else if (parseInt(new_version[i] || 0, 10) < parseInt(version[i] || 0, 10)) {
            return false;
        }
    }

    return false;
}

/**
 * This object allows you to pass a list of events to listen to. Once all of them are done, it will fire a callback
 * @class utils.CallbackGroup
 * @constructor
 *
 * @param {object} params
 *  @param {object} params.events a map of event-name => event target
 *  @param {function} params.callback    a function to run once events are done
 *
 *  @example
 *      var group = new utils.CallbackGroup({
 *          callback : function(){console.log('foo');},
 *          events :{
 *              'load' : this.bridge,
 *              'iclick' : this.element
 *          }
 *      });
 */
function CallbackGroup(params) {
    var ev,
        counter = 0,
        max = 0,
        stopped,
        _params = params;

    function attach(target, type) {
        if (target.addEventOnce) {
            target.addEventOnce(type, fire);
        } else {
            target.addEventListener(type, function once() {
                fire();
                target.removeEventListener(type, once, false);
            }, false);
        }
    }

    /**
     * cancels the stack
     * @method stop
     * @param {boolean} [run] if set to true will run the callback
     */
    function stop(run) {
        if (run) {
            _params.callback();
        }

        stopped = true;

        _params = null;
    }

    function fire() {
        counter++;
        if (counter == max && !stopped) {
            stop(true);
        }
    }

    for (ev in _params.events) {
        attach(_params.events[ev], ev);
        max++;
    }

    return {
        constructor: CallbackGroup,
        stop: stop
    };
}

function logStorage() {
    var arr = [];
    for (var name in localStorage) {
        arr.push({ name: name, l: localStorage[name].length });
    }arr.sort(function (a, b) {
        return +a.l > +b.l;
    });

    arr.forEach(function (p) {
        console.log(p.l + ':' + p.name);
    });
}

/**
 * a utility for overriding the behavior of a function
 *
 * New function will receive the original function as it's first paramater, and will be run under
 * the scope of `obj` (if supplied)
 *
 * @param {Function} orig_fn the original function
 * @param {Function} new_fn  the replacing function
 * @param {Object}  [obj]    which object to bind the function to
 *
 * @returns {Function}
 */
function overload(orig_fn, new_fn, obj) {
    return new_fn.bind(obj, orig_fn);
}

utils.bind = function (fn, scope) {
    return fn.bind(scope);
};

utils.overload = overload;
utils.logStorage = logStorage;
utils.CallbackGroup = CallbackGroup;
utils.isNewerVersion = isNewerVersion;
utils.openLinkInNewWindow = openLinkInNewWindow;
utils.bindParent = bindParent;
utils.sendSelectedText = sendSelectedText;
utils.log = log;
utils.warn = warn;
utils.log = log;
//mimickin corc's Object.create
utils.inherit = inherit;
utils.has = has;
utils.exists = exists;
utils.find = find;
utils.cloneArr = cloneArr;
utils.toArray = toArray;
utils.arrRemove = arrRemove;
utils.removeItem = removeItem;
utils.indexOf = indexOf;
utils.keys = keys;
utils.merge = merge;
utils.prefech = prefetch;
utils.median = median;
utils.average = average;
utils.min = min;
utils.max = max;
var main = exports.main = utils;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/utils.main.js
// module id = 72
// module chunks = 0